import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const StatisticsBlockSkeleton = () => {
  return [...Array(4)].map((_) => (
    <div key={uuidv4()} className={style.statItem}>
      <div className={style.statItemInfo}>
        <div className={style.statItemText}>
          <SkeletonBlock className={style.skeletonTextClassName} />
        </div>
        <div className={style.statItemQuantity}>
          <SkeletonBlock className={style.skeletonTextClassName} />
        </div>
      </div>
      <SkeletonBlock />
    </div>
  ));
};

export default StatisticsBlockSkeleton;
